module.exports = "/images/camera.svg?32711260c5065da4d2f73730eeb6fdac";